import "./landingPage.css";
import React, { memo, useState, useEffect } from "react";
import ReactCardFlip from "react-card-flip";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

import LoginForm from "./Login/LoginForm";
import SignUpForm from "./SignUpForm/SignUpForm";
import ResetPasswordDialog from "./Login/ResetPasswordDialoge";
import { useAppContext } from "../../context/appContext";
import "./landingPage.css";

import AOS from "aos";
import "aos/dist/aos.css";

import LandingPageStory from "./Story/LandingPageStory";
import LandingPageVideo from "./Video/LandingPageVideo";

function LandingPage() {
  const theme = useTheme();
  const { isMobile, loading } = useAppContext();

  const [seeLogin, setSeeLogin] = useState(true);
  const [openResetDialog, setOpenResetDialog] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true, // ✅ animate only once (important)
      easing: "ease-out-cubic",
      // startEvent: "load", // ✅ ensures proper timing
    });

    AOS.refresh();
  }, []);

  const changeView = () => {
    setSeeLogin((prev) => !prev);
  };

  // ✅ optional loading screen
  if (loading) {
    return (
      <div className="background">
        <div className="loadingContainer">
          <img
            className="loading"
            src="./static/images/login/logo512.png"
            alt="logo"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="background">
      {/* ✅ HEADER - centered auth card*/}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          minHeight: isMobile
            ? seeLogin
              ? "80dvh"
              : "100dvh"
            : seeLogin
              ? "90dvh"
              : "90dvh",
          px: 2,
        }}
      >
        <Box
          sx={{
            borderRadius: 3,
            width: isMobile ? "100%" : "700px",
            maxWidth: 700,
            boxShadow: "0px 4px 16px rgba(0,0,0,0.9)",
            backgroundColor: theme.palette.background.paper,
            p: isMobile ? 2 : 3,
          }}
        >
          <ReactCardFlip isFlipped={!seeLogin} flipDirection="horizontal">
            <LoginForm
              flipCard={changeView}
              seeLogin={seeLogin}
              setOpenResetDialog={setOpenResetDialog}
            />

            <SignUpForm
              flipCard={changeView}
              seeLogin={seeLogin}
              setOpenResetDialog={setOpenResetDialog}
            />
          </ReactCardFlip>
        </Box>
      </Box>
      {/* ✅ EXPLANATION VIDEO */}
      <LandingPageVideo />
      {/* ✅ STORY BELOW (desktop only if you want) */}
      {!isMobile && <LandingPageStory />}
      {/* ✅ RESET DIALOG */}
      <ResetPasswordDialog
        open={openResetDialog}
        onClose={() => setOpenResetDialog(false)}
      />
    </div>
  );
}

export default memo(LandingPage);
